import React from 'react'
import { Alert } from 'antd'
import './serviceTerminationNotice.less'

const ServiceTerminationNotice = () => (
  <Alert
    banner
    showIcon
    type='warning'
    className='service-termination-notice'
    message='Local-Heroes ayant rempli sa mission depuis longtemps déjà, cette plateforme sera désactivée le 31 décembre 2026.'
  />
)

export default ServiceTerminationNotice
